export default [
    {id: 1, instant: true, collection: 'preciousJewelry', reward: [
        {name: 'school_goldenDust', type: 'currency', value: 1000}
    ], color: 'red', icons: [
        {"x": 0, "y": -0.05, "rotate": 0, "size": 2, "icon": "mdi-train"},
        {"x": 0.15, "y": 0.85, "rotate": 90, "size": 2, "icon": "mdi-fence"},
        {"x": 0, "y": -0.75, "rotate": 0, "size": 1, "icon": "mdi-rhombus"}
    ]},
    {id: 2, instant: true, collection: 'preciousJewelry', reward: [
        {name: 'school_goldenDust', type: 'currency', value: 1000}
    ], color: 'green', icons: [
        {"x": -0.25, "y": 0, "rotate": 0, "size": 3, "icon": "mdi-tunnel-outline"},
        {"x": 0.8, "y": 0.4, "rotate": 105, "size": 1.5, "icon": "mdi-pickaxe"},
        {"x": -0.4, "y": 0.35, "rotate": 0, "size": 0.5, "icon": "mdi-hexagon"},
        {"x": 0, "y": 0.25, "rotate": 0, "size": 0.5, "icon": "mdi-hexagon"},
        {"x": -0.25, "y": -0.25, "rotate": 0, "size": 0.5, "icon": "mdi-hexagon"}
    ]},
    {id: 3, instant: true, collection: 'preciousJewelry', reward: [
        {name: 'school_goldenDust', type: 'currency', value: 1000}
    ], color: 'indigo', icons: [
        {"x": -0.15, "y": 1.1, "rotate": 0, "size": 1.5, "icon": "mdi-sail-boat-sink"},
        {"x": 0.2, "y": 1.15, "rotate": 0, "size": 0.65, "icon": "mdi-treasure-chest"},
        {"x": 0, "y": -0.26, "rotate": 0, "size": 1.5, "icon": "mdi-ferry"},
        {"x": -0.65, "y": 0.3, "rotate": 0, "size": 1.5, "icon": "mdi-waves"},
        {"x": 0, "y": 0.3, "rotate": 0, "size": 1.5, "icon": "mdi-waves"},
        {"x": 0.65, "y": 0.3, "rotate": 0, "size": 1.5, "icon": "mdi-waves"},
        {"x": 0.25, "y": 0.95, "rotate": 0, "size": 0.4, "icon": "mdi-pentagon"}
    ]},
    {id: 4, instant: true, collection: 'preciousJewelry', reward: [
        {name: 'school_goldenDust', type: 'currency', value: 1000}
    ], color: 'purple', icons: [
        {"x": 0, "y": 0, "rotate": 0, "size": 4, "icon": "mdi-watch-variant"},
        {"x": 0, "y": -0.15, "rotate": 90, "size": 1, "icon": "mdi-minus"},
        {"x": -0.3, "y": -0.3, "rotate": -45, "size": 0.65, "icon": "mdi-cards-diamond"},
        {"x": 0.3, "y": -0.3, "rotate": 45, "size": 0.65, "icon": "mdi-cards-diamond"},
        {"x": 0.3, "y": 0.3, "rotate": -45, "size": 0.65, "icon": "mdi-cards-diamond"},
        {"x": -0.3, "y": 0.3, "rotate": 45, "size": 0.65, "icon": "mdi-cards-diamond"},
        {"x": -0.1, "y": 0.05, "rotate": -20, "size": 0.6, "icon": "mdi-minus-thick"}
    ]},
    {id: 5, instant: true, collection: 'preciousJewelry', reward: [
        {name: 'school_goldenDust', type: 'currency', value: 1000}
    ], color: 'amber', icons: [
        {"x": 0, "y": -0.6, "rotate": 0, "size": 2, "icon": "mdi-triangle-outline"},
        {"x": -0.7, "y": 0.6, "rotate": 0, "size": 2, "icon": "mdi-triangle"},
        {"x": 0.7, "y": 0.6, "rotate": 0, "size": 2, "icon": "mdi-triangle"},
        {"x": 0, "y": -0.5, "rotate": 0, "size": 1.15, "icon": "mdi-emoticon-angry"}
    ]},
    {id: 6, instant: true, collection: 'preciousJewelry', reward: [
        {name: 'school_goldenDust', type: 'currency', value: 2500}
    ], color: 'cyan', icons: [
        {"x": 0, "y": 0, "rotate": -45, "size": 2, "icon": "mdi-pickaxe"},
        {"x": 0.7, "y": 0.25, "rotate": 0, "size": 2, "icon": "mdi-axe"},
        {"x": -0.7, "y": 0.3, "rotate": 95, "size": 2, "icon": "mdi-shovel"},
        {"x": -0.5, "y": -0.7, "rotate": 0, "size": 0.75, "icon": "mdi-diamond"},
        {"x": 0.5, "y": -0.7, "rotate": 0, "size": 0.75, "icon": "mdi-diamond"}
    ]},
    {id: 7, instant: true, collection: 'preciousJewelry', reward: [
        {name: 'school_goldenDust', type: 'currency', value: 8000}
    ], color: 'deep-purple', icons: [
        {"x": 0, "y": 0.15, "rotate": 0, "size": 0.75, "icon": "mdi-octagon"},
        {"x": 0, "y": 0, "rotate": 90, "size": 2, "icon": "mdi-mirror-rectangle"},
        {"x": 0, "y": 0.85, "rotate": 0, "size": 2.5, "icon": "mdi-dresser"},
        {"x": 1.1, "y": -0.8, "rotate": 0, "size": 1.25, "icon": "mdi-cctv"}
    ]},
];
